import { Box, Typography } from '@mui/material'
import { PATH_ROOT } from 'constants/api'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const AccountAlreadyExists = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    return (
        <Box>
            <Typography>{t('dialog.regiter-sso-no-sso.has-account')}</Typography>
            <Typography sx={{ textDecoration: 'underline', cursor: 'pointer', color: theme => theme.palette.primary.main }} tabIndex={0} onClick={() => navigate(`${PATH_ROOT}/auth/login`)} onKeyDown={(e) => { if (e.key === "Enter") navigate(`${PATH_ROOT}/auth/login`) }}>{t('dialog.regiter-sso-no-sso.login')}</Typography>
        </Box>
    )
}

export default AccountAlreadyExists